import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

/**
 * SocialProofStats - Read-only aggregate rating display.
 *
 * Shows star rating, review count, and customer count as chips.
 */
function SocialProofStats({ rating, reviewCount, customerCount }) {
  const { t } = useTranslation('approval')

  if (!rating && !reviewCount) return null

  const formatCount = (num) => {
    if (!num) return null
    if (num >= 10000) return `${Math.round(num / 1000)}k+`
    if (num >= 1000) return `${(num / 1000).toFixed(1)}k`
    return num.toLocaleString('de-DE')
  }

  const fullStars = Math.floor(rating || 0)
  const hasHalf = (rating || 0) - fullStars >= 0.5
  const stars = '★'.repeat(fullStars) + (hasHalf ? '½' : '') + '☆'.repeat(5 - fullStars - (hasHalf ? 1 : 0))

  return (
    <div className="space-y-2">
      <h4 className="text-sm font-medium text-gray-700">
        {t('socialProof.aggregateHeading', 'Gesamtbewertung (aus Feed)')}
      </h4>
      <div className="flex flex-wrap gap-2">
        {rating > 0 && (
          <span className="rounded-full bg-gray-100 px-3 py-1.5 text-sm">
            <span className="text-yellow-400">{stars}</span>
            {' '}{rating.toFixed(1)} / 5.0
          </span>
        )}
        {reviewCount > 0 && (
          <span className="rounded-full bg-gray-100 px-3 py-1.5 text-sm">
            {formatCount(reviewCount)} {t('socialProof.reviews', 'Bewertungen')}
          </span>
        )}
        {customerCount > 0 && (
          <span className="rounded-full bg-gray-100 px-3 py-1.5 text-sm">
            {formatCount(customerCount)} {t('socialProof.customers', 'Kunden')}
          </span>
        )}
      </div>
    </div>
  )
}

SocialProofStats.propTypes = {
  rating: PropTypes.number,
  reviewCount: PropTypes.number,
  customerCount: PropTypes.number,
}

export default SocialProofStats
